import type { Translate } from "@similarweb/i18n-provider";

import type { LocationDevice } from "app/pages/digital-marketing/keywords-campaigns/shared/types";
import { isMobileDevice } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const buildSerpOverlayPageTabs = (recordsCount: number, translate: Translate) =>
    Array.from({ length: Math.max(recordsCount, 1) }, (_, index) => {
        const pageNumber = index + 1;
        return {
            id: String(index),
            label: translate("rankTracker.serpOverlay.pageTab.label", { pageNumber }),
            pageNumber,
        };
    });

/** Route (`devicesTypes`) or API (`DEVICES_TYPES_FOR_API`) device → overlay header device. */
export const toSerpOverlayLocationDevice = (device: string | undefined): LocationDevice | undefined => {
    if (!device) {
        return undefined;
    }
    if (isMobileDevice(device)) {
        return "MOBILE";
    }
    return "DESKTOP";
};
